import api from './api';

export const playerService = {
  async getConfig() {
    const response = await api.get('/players/config');
    return response.data;
  },

  async googleLogin(googleToken) {
    const response = await api.post('/players/google-login', { google_token: googleToken });
    return response.data;
  },

  async getMyProfile() {
    const response = await api.get('/players/me');
    return response.data;
  },

  async getPlayerProfile(playerId) {
    const response = await api.get(`/players/${playerId}`);
    return response.data;
  },

  async getLeaderboard(params = {}) {
    const response = await api.get('/players/leaderboard', { params });
    return response.data;
  },

  logout() {
    localStorage.removeItem('playerToken');
    localStorage.removeItem('playerAuth');
  }
};
